import axios from 'axios';

const RESOURCE_NAME = '/startups';

export default {

    getDetails(startupId) {
        return axios.get(`${RESOURCE_NAME}/` + startupId + `/get-details`)
    },

    getCommonData(startupId) {
        return axios.get(`${RESOURCE_NAME}/` + startupId + `/get-common-data`)
    },

    getCustomData(startupId, type) {
        return axios.get(`${RESOURCE_NAME}/` + startupId + `/get-custom-data?type=${type}`)
    },

    getEcosystemsData(startupId) {
        return axios.get(`${RESOURCE_NAME}/` + startupId + `/get-ecosystems-data`)
    },

    getTrackers(startupId) {
        return axios.get(`${RESOURCE_NAME}/` + startupId + `/get-trackers`)
    },

    getTasksCount(startupId) {
        return axios.get(`${RESOURCE_NAME}/` + startupId + `/get-tasks-count`)
    },

    getCustomFieldValue(startupId, fieldId) {
        return axios.get(`${RESOURCE_NAME}/` + startupId + `/get-custom-field-value?field_id=${fieldId}`)
    },

    getTags(startupId) {
        return axios.get(`${RESOURCE_NAME}/` + startupId + `/get-tags`)
    },

    getNews(startupId) {
        return axios.get(`${RESOURCE_NAME}/` + startupId + `/get-news`)
    },

    getInvestors(startupId) {
        return axios.get(`${RESOURCE_NAME}/` + startupId + `/get-investors`)
    },

    getActivities(startupId, data) {
        return axios.post(`${RESOURCE_NAME}/` + startupId + `/get-activities`, data)
    },

    removeActivity(logId) {
        return axios.post(`${RESOURCE_NAME}/remove-activity?log_id=${logId}`)
    },

    saveCustomValue(startupId, fieldId, data) {
        return axios.post(`${RESOURCE_NAME}/` + startupId + `/save-custom-value?field_id=${fieldId}`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
    },

    saveCustomFiles(startupId, fieldId, data) {
        return axios.post(`${RESOURCE_NAME}/` + startupId + `/save-custom-files?field_id=${fieldId}`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
    },

    getContacts(startupId, search) {
        return axios.get(`${RESOURCE_NAME}/` + startupId + `/get-contacts?search=${search}`)
    },

    saveNote(startupId, noteId, data) {
        return axios.post(`${RESOURCE_NAME}/` + startupId + `/save-note?note_id=${noteId}`, data)
    },

    getNoteEdit(startupId, noteId) {
        return axios.get(`${RESOURCE_NAME}/` + startupId + `/get-note-edit?note_id=${noteId}`)
    },

    getFundingRounds(startupId) {
        return axios.get(`${RESOURCE_NAME}/` + startupId + `/get-funding-rounds`)
    },

    getDataForPdf(startupId) {
        return axios.get(`${RESOURCE_NAME}/` + startupId + `/get-data-for-pdf`)
    },

    addErrorReport(startupId, data) {
        return axios.post(`${RESOURCE_NAME}/` + startupId + `/add-error-report`, data)
    },

    getList(search) {
        return axios.post(`${RESOURCE_NAME}/get-list`, {search: search})
    },

    getStartupForSelect(startupId) {
        return axios.get(`${RESOURCE_NAME}/` + startupId + `/get-startup-for-select`)
    },

    getLastAddedStartups() {
        return axios.get(`${RESOURCE_NAME}/get-last-added-startups`)
    },

    addCategories(startupId, data) {
        return axios.post(`${RESOURCE_NAME}/` + startupId + `/add-categories`, data)
    },

    setLocation(startupId, data) {
        return axios.post(`${RESOURCE_NAME}/` + startupId + `/set-location`, data)
    },
}